export default __webpack_public_path__ + "static/media/brainHealthStudio1.edc6533b.png";